import { render, staticRenderFns } from "./filterprojectreport.vue?vue&type=template&id=385e8350"
import script from "./filterprojectreport.vue?vue&type=script&lang=js"
export * from "./filterprojectreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports